// src/layout/LayoutContext.jsx
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const LayoutContext = createContext();
export const useLayout = () => useContext(LayoutContext);

const XL_BREAKPOINT = 1200;

export const LayoutProvider = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isXLUp, setIsXLUp] = useState(typeof window !== 'undefined' ? window.innerWidth >= XL_BREAKPOINT : true);

  // <-- NEW: état "collapsed" persisté
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('tg_sidebar_collapsed') || 'false'); } catch { return false; }
  });

  const handleResize = useCallback(() => {
    const xl = window.innerWidth >= XL_BREAKPOINT;
    setIsXLUp(xl);
    setSidebarOpen(xl ? true : false);
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  const openSidebar  = () => setSidebarOpen(true);
  const closeSidebar = () => setSidebarOpen(false);
  const toggleSidebar = () => setSidebarOpen(v => !v);

  // <-- NEW
  const toggleCollapsed = () => {
    setIsCollapsed(v => {
      const nv = !v;
      try { localStorage.setItem('tg_sidebar_collapsed', JSON.stringify(nv)); } catch {}
      return nv;
    });
  };

  return (
    <LayoutContext.Provider
      value={{ sidebarOpen, isXLUp, openSidebar, closeSidebar, toggleSidebar, isCollapsed, toggleCollapsed }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
